module.exports = __webpack_public_path__ + "img/news2-1.4348b7bc.jpg";